module.exports = __webpack_public_path__ + "img/arrow-forward.f9bbf79b.svg";